import { Fragment } from 'react';

export type LayoutProps = React.HTMLAttributes<HTMLDivElement> & {
	divider?: React.ReactNode;
	children: JSX.Element[];
};

export const Layout: React.FC<LayoutProps> = ({
	divider,
	children,
	className,
	...props
}) => (
	<div
		className={`cart-items-layout${className ? ` ${className}` : ''}`}
		{...props}
	>
		{children.map((item, key) => (
			<Fragment key={key}>
				{key !== 0 && divider}
				{item}
			</Fragment>
		))}
	</div>
);
